<template>
    <div class="data-view">
        <header class="dv-header">
            <div class="sec-1">
                <span class="dv-title">数据管理</span>
                <label class="dv-label">当前项目: </label>
                <span class="proj-name">{{projectName}}</span>
                <el-popover
                        placement="bottom"
                        title="切换项目"
                        width="675"
                        v-model="projVisible"
                        trigger="click">
                    <div class="data-view-projs">
                        <ul>
                            <li @click="onProjectChange(item)" v-for="(item, index) in  projects" :key="index" :class="{disable: item.status === 'PENDING'}">
                                <span v-if="item.status === 'PENDING'" class="p-approval"><i class="el-icon-s-custom"></i>审核中</span>
                                <p>{{item.name}}</p>
                            </li>
                        </ul>
                    </div>
                    <a slot="reference" class="c-main-color"><i class="iconfont icon-change"></i> 切换项目</a>
                </el-popover>
            </div>
        </header>
        <div class="dv-bg">
           <div class="dv-bg-layout">
               <section class="dv-tools">
                   <label class="time-title">选择时间</label>
                   <span class="time-tools">
                         <span class="time-link" :class=" tableOptions.params.reqTime === 'YESTERDAY' && 'active'" @click="onTimeClick('YESTERDAY')">昨日</span>
                        <span class="time-link" :class=" tableOptions.params.reqTime === 'LATEST_WEEK' && 'active'" @click="onTimeClick('LATEST_WEEK')">近7天</span>
                        <span class="time-link" :class=" tableOptions.params.reqTime === 'LATEST_30_DAYS' && 'active'" @click="onTimeClick('LATEST_30_DAYS')">近30天</span>
                        <el-date-picker class="c-time-section" value-format="yyyy-MM-dd HH:mm:ss" @change="onTimeChange"
                                        v-model="time"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                    </el-date-picker>
                    </span>
                   <span class="c-search-box c-f-right" v-if="!detailVisible">
                        <el-input v-model="tableOptions.params.templateName" placeholder="搜索模板名称" class="search-ipt"></el-input>
                        <el-button @click="onSearch" type="primary" circle class="c-search-btn"><i class="iconfont icon-search"></i></el-button>
                    </span>
               </section>
               <section  v-if="!detailVisible" class="dv-body mtop">
                   <div>
                       <div class="dv-view">
                           <ul>
                               <li>
                                   <div class="dvv-title">项目成员数</div>
                                   <div class="dvv-body">{{dataMap.userCount || 0}}</div>
                               </li>
                               <li>
                                   <div class="dvv-title">
                                       Banner下载总数</div>
                                   <div class="dvv-body">{{dataMap.bannerDownloadCount || 0}}</div>
                               </li>
                               <li>
                                   <div class="dvv-title">图文模板下载总数</div>
                                   <div class="dvv-body">{{dataMap.multiTemplateDownloadCount || 0}}</div>
                               </li>
                               <li>
                                   <div class="dvv-title">PPT模板下载总数</div>
                                   <div class="dvv-body">{{dataMap.pptTemplateDownloadCount || 0}}</div>
                               </li>
                               <li>
                                   <div class="dvv-title">平均编辑模板时长</div>
                                   <div class="dvv-body">{{dataMap.editTemplateAvgTime || 0}}s</div>
                               </li>
                           </ul>
                       </div>
                       <div class="dv-table mtop">
                           <el-table :data="tableDataMixin" class="table-area" v-loading="tableLoadingMixin"
                                     element-loading-text="拼命查询中, 请稍候"
                                     element-loading-spinner="el-icon-loading"
                                     style="width: 100%">
                               <el-table-column label="模块信息"  prop="templateName" min-width="300">
                                   <template slot-scope="scope">
                                       <div class="dvt-col-tpl">
                                           <img :src="scope.row.templateDefaultUrl"/><span>{{scope.row.displayName}}</span>
                                       </div>
                                   </template>
                               </el-table-column>
                               <el-table-column  label="下载总次数"  prop="downloadCount"  min-width="100">
                               </el-table-column>
                               <el-table-column  label="完成下载的成员数"  prop="downloadUserCount"  min-width="140">
                               </el-table-column>
                               <el-table-column  label="查看详情"  prop="downloadUserCount"  width="90">
                                   <template slot-scope="scope">
                                       <el-button type="text" v-if="scope.row.templateType !== 'SINGLE'" @click="onOpenWin(scope.row.tplGroupId)">查看</el-button>
                                   </template>
                               </el-table-column>
                           </el-table>
                           <div class="no-data" v-show="tableDataMixin.length === 0 && !tableLoadingMixin">
                               <noResult>
                                   <div class="title">暂无数据</div>
                               </noResult>
                           </div>
                           <el-pagination class="page-area" v-if="tableDataMixin.length"
                                          background
                                          :total="totalDataMixin"
                                          :page-size="queryMixin.pageSize"
                                          :page-sizes="[10, 20, 30]"
                                          layout="sizes, total, ->, prev, pager, next, jumper"
                                          :current-page="queryMixin.pageNum"
                                          @size-change="handleSizeChangeMixin"
                                          @current-change="handleCurrentChangeMixin">
                           </el-pagination>
                       </div>
                   </div>
               </section>
               <section v-else class="dv-body mtop">
                   <template-view v-model="detailVisible" :tplGroupId="tplGroupId" :params="tableOptions.params"></template-view>
               </section>
           </div>
        </div>
    </div>
</template>
<script>
    import mix from '@/mixins/table-mixin.js';
    import {TEMPLATE_VIEW_TABLE} from '../../../request/api/template-api'
    import noResult from '@/views/components/noResult'
    import templateView from './template-view'
    export default {
        mixins: [mix],
        components:{noResult, templateView},
        data(){
            return {
                detailVisible: false,
                projectName: null,
                time: null,
                projVisible: false,
                tableOptions: {
                    url: TEMPLATE_VIEW_TABLE,
                    params: {
                        projectId: '',
                        startTimeFrom: '',
                        startTimeTo: '',
                        reqTime: 'YESTERDAY',
                        templateName: '',
                    }
                },
                dataMap:{
                    userCount: '',
                    bannerDownloadCount: 0,
                    multiTemplateDownloadCount: 0,
                    pptTemplateDownloadCount: 0,
                    editTemplateAvgTime: 0,
                    templateStats: []
                },
                tplGroupId: null
            };
        },
        computed: {
            projects () {
                return this.$store.state.app.adminProjects;
            },
        },
        watch:{
            projects:{
                handler(arr){
                    if(arr.length > 0){
                        this.tableOptions.params.projectId = arr[0].id;
                        this.projectName = arr[0].name;
                        this.getData();
                    }
                },
                immediate: true,
                deep: true
            }
        },
        created(){
        },
        methods:{
            init(){
                this.getData();
            },
            getData(){
                return this.getDataMixin().then((data) => {
                    Object.assign(this.dataMap, data);
                })
            },
            onSearch(){
                let obj = this.validate();
                if(!obj.valid){
                    this.$message.error(obj.message);
                    return;
                }
                this.getData();
            },
            isEmpty(val){
                return val === null || val === undefined || val.toString() === '';
            },
            validate(){
                let data = this.tableOptions.params;
                let hasProjectVal = !this.isEmpty(data.projectId);
                if(!hasProjectVal){
                  return {
                      valid: false ,message: '请选择项目'
                  }
                }
                let hasTimeVal = (!this.isEmpty(data.startTimeFrom) && !this.isEmpty(data.startTimeTo)) || !this.isEmpty(data.reqTime);
                if(!hasTimeVal){
                    return {
                        valid: false ,message: '请选择时间'
                    }
                }
                return {
                    valid: true
                };
            },
            onTimeChange(data){
                let startTimeFrom = null, startTimeTo = null;
                if(data && data.length > 0){
                    startTimeFrom = data[0];
                    startTimeTo = data[1];
                }
                this.tableOptions.params.startTimeFrom = startTimeFrom;
                this.tableOptions.params.startTimeTo = startTimeTo;
                this.tableOptions.params.reqTime = null;
                this.onSearch();
            },
            onTimeClick(reqTime){
                this.tableOptions.params.reqTime = reqTime;
                this.time = null;
                this.tableOptions.params.startTimeFrom = null;
                this.tableOptions.params.startTimeTo = null;
                this.onSearch();
            },
            onProjectChange(item){
                this.detailVisible = false;
                if (item.status === 'PENDING') {
                  return;
                }
                this.projVisible = false;
                this.projectName = item.name;
                this.tableOptions.params.projectId = item.id;
                this.onSearch();
            },
            onOpenWin(tplGroupId){
                this.tplGroupId = tplGroupId;
                this.detailVisible = true;
            }
        }
    }
</script>
<style lang="scss">
    @import "./data-view";
</style>